module.exports = __webpack_public_path__ + "img/tip2.c77193c4.png";